import { Label, TextStyle, TextField } from "@lannister/duplo";

import { ReactComponent as CardIcon } from "../../assets/icons/card.svg";
import { ReactComponent as CalendarIcon } from "../../assets/icons/calendar.svg";
import { ReactComponent as EyeOffIcon } from "../../assets/icons/eye-slash.svg";

import { ValidateNumeric, FormatExpiryDate, FormatCardNumber } from "./utils";

const CardDetailsForm = ({ form, handleChange }) => {

  return (
        <div style={styles.card}>
          <Label
            labelText="Payment Card Details"
            textStyle={TextStyle.Heading5Semibold}
          />

          <div style={styles.row}>
              <div style={styles.field}>
                  <TextField
                    label="First Name"
                    value={form.first_name}
                    onChange={handleChange("first_name")}
                    maxLength={50}
                  />
              </div>
              <div style={styles.field}>
                  <TextField
                    label="Last Name"
                    value={form.last_name}
                    onChange={handleChange("last_name")}
                    maxLength={50}
                  />
              </div>
          </div>

          <TextField
              label="Card Number"
              value={form.payment_number}
              onChange={handleChange("payment_number")}
              rightIcon={<CardIcon />}
              maxLength={19}
              onInput={
                (event) => {
                  ValidateNumeric(event);
                  FormatCardNumber(event);
                }}
          />

          <div style={styles.row}>
              <div style={styles.field}>
                  <TextField
                    label="MM/YY"
                    value={form.expiry_date}
                    onChange={handleChange("expiry_date")}
                    rightIcon={<CalendarIcon />}
                    maxLength={5}
                    onInput={
                      (event) => {
                        ValidateNumeric(event);
                        FormatExpiryDate(event, form.expiry_date);
                      }}
                  />
              </div>
              <div style={styles.field}>
                  <TextField
                    label="CVV"
                    value={form.cvv}
                    onChange={handleChange("cvv")}
                    rightIcon={<EyeOffIcon />}
                    onInput={(event) => ValidateNumeric(event)}
                    maxLength={3}
                  />
              </div>
          </div>
        </div>
  );
};

const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid #E0E0E0",
    backgroundColor: "#FFFFFF",
    width: "100%",
    boxSizing: "border-box",
  },
  row: {
    display: "flex",
    gap: "12px",
  },
  field: {
    flex: 1,
    minWidth: 0,
  },
};

export default CardDetailsForm;
